import { useMemo } from 'react';
import { format, formatDistanceToNow, isToday } from 'date-fns';
import { zhCN } from 'date-fns/locale';
import { Message } from '../../../types/chat';

type GroupedMessage = Message | { type: 'date'; date: string };

export const useMessageGrouping = (messages: Message[]) => {
    const groupedMessages = useMemo(() => {
        const result: GroupedMessage[] = [];
        let groupStartTime: number | null = null;

        messages.forEach((msg) => {
            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const currentTimestamp = new Date(new Date(`${msg.timestamp}`).toLocaleString("en-US", { timeZone: userTimeZone })).getTime();
            
            if (!groupStartTime || currentTimestamp - groupStartTime >= 5 * 60 * 1000) {
                const date = new Date(currentTimestamp);
                const dateLabel = isToday(date)
                    ? formatDistanceToNow(date, { addSuffix: true, locale: zhCN })
                    : format(date, 'MM-dd HH:mm', { locale: zhCN });
                result.push({ type: 'date', date: dateLabel });
                groupStartTime = currentTimestamp;
            }
            result.push(msg);
        });

        return result;
    }, [messages]);

    return { groupedMessages };
}; 